// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1t5nE","left":"styles_left__3YWuP"};